<template>
  <div class="product-container">
    <nav class="nav-header"> 
      <p @click="$router.push({name: 'company-admin-bulk-sending-send'})"
         :class="($route.name === 'company-admin-bulk-sending-send') ? 'active' : ''">Send Bulk</p>
      <p @click="$router.push({name: 'company-admin-bulk-sending-history'})"
         :class="($route.name === 'company-admin-bulk-sending-history') ? 'active' : ''">History</p>
    </nav>
    <router-view
    ass="router-container" />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.product-container {
    height: auto;
    padding: 0 20px;
}
.product-container .nav-header {
    margin: 0 -20px;
}
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 20px 0px 20px;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-bottom: 0;
      color: #bdbfd8;
      font-family: ""Helvetica Neue"";
      font-size: 16px;
      font-weight: 300;
      line-height: 20px;
      text-align: center;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
  }
}
</style>

